  <div class="cdk-visually-hidden" role="status" aria-live="polite" aria-atomic="true">
  {{ content.announcedTitle }}
</div>
@if (content.pageTitle) {
  <div class="nsc-page-title">
    <h2 tabindex="-1">{{ content.pageTitle }} </h2>
    @if (content.pageTitle == 'Order a Transcript') {
        <a id="schoolselect_addprocess"
          [href]="processFlowURL" target="_blank" rel="noopener"
          aria-describedby="processlink_desc_pt">
          Learn How the Process Works
        </a>
        <span id="processlink_desc_pt" class="cdk-visually-hidden" aria-hidden="true">opens in new window</span>
      }
      @if (content.recipient) {
        <p  ><strong>Send To:</strong> {{content.recipient}}</p>
      }
      <nsc-spacer size="md"></nsc-spacer>
    </div>
  }